function switchTab() {
  const tabs = document.querySelectorAll(".tab-header__item"),
    tabsContent = document.querySelectorAll(".tab-content__text"),
    tabsParent = document.querySelector(".tab-header__items");

  function observeQuestElement() {
    const observer = new MutationObserver(() => {
      const question = document.querySelector('.tab-content__text--question #judgeme_product_reviews [data-tabname="questions"]');
      if (question && !question.classList.contains('test')) {
        question.click();
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  observeQuestElement();

  function hideTabContent() {
    if (tabsContent.length) {
      tabsContent.forEach((el) => {
        el.classList.add("hide");
        el.classList.remove("show", "fade");
      });
    }

    if (tabs.length) {
      tabs.forEach((tab) => {
        tab.classList.remove("active");
      });
    }
  }

  function showTabContent(i = 0) {
    if (tabsContent.length > 0) {
      tabsContent[i]?.classList.add("show", "fade");
      tabsContent[i]?.classList.remove("hide");
    }

    if (tabs.length > 0) {
      tabs[i]?.classList.add("active");
    }
  }

  hideTabContent();
  if (tabs.length === 1) {
    showTabContent(0);
  } else {
    showTabContent();
  }

  tabsParent?.addEventListener("click", (e) => {
    const target = e.target;

    if (target && target.classList.contains("tab-header__item")) {
      tabs.forEach((item, i) => {
        if (target === item) {
          hideTabContent();
          showTabContent(i);
        }
      });
    }
  });

  let firstNonEmptyFound = false;

  tabsContent.forEach(tab => {
      if (tab.children.length > 0) {
          if (!firstNonEmptyFound) {
              tab.classList.add("show");
              firstNonEmptyFound = true;
          }
          tab.classList.remove("hide");
      } else {
          tab.classList.add("hide");
      }
  });

}


switchTab();

function tabsDropDown() {
  const tabParentMob = document.querySelector(".tab-header__items--mob");

  tabParentMob?.addEventListener("click", () => {
    tabParentMob.classList.toggle("open");
  });
}

tabsDropDown();

function tabTitleCount() {
  const reviewsSelector = ".jdgm-prev-badge__text";
  const questionSelector = ".jdgm-qa-badge__text";
  const questionTabSelector = "[data-app-title-question]";
  const reviewsTabSelector = "[data-app-title-reviews]";
  const tabParentMobSelector = ".tab-header__items--mob";

  const reviewsTab = document.querySelector(reviewsTabSelector);
  const questionTab = document.querySelector(questionTabSelector);
  const tabParentMob = document.querySelector(tabParentMobSelector);

  if (!reviewsTab || !questionTab || !tabParentMob) {
    return;
  }

  const extractNumber = (text) => text.replace(/[^0-9]/g, "");

  const updateReviewsTab = () => {
    const reviewsCount = document.querySelector(reviewsSelector)?.textContent;
    if (reviewsCount) {
      const extractedCount = extractNumber(reviewsCount);
      if (extractedCount) {
        reviewsTab.textContent += ` (${extractedCount})`;
      }
    }
  };

  const updateQuestionTab = () => {
    const observer = new MutationObserver(() => {
      const questionCountElement = document.querySelector(questionSelector);

      if (questionCountElement) {
        const questionCount = extractNumber(questionCountElement.textContent);
        if (questionCount) {
          questionTab.textContent += ` (${questionCount})`;
        }

        attachEventListeners();
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  const attachEventListeners = () => {
    const questionBadge = document.querySelector(".jdgm-qa-badge");
    const starsBadge = document.querySelector(".jdgm-prev-badge__stars");
    const reviewsBadge = document.querySelector(".jdgm-prev-badge__text");

    if (questionBadge) {
      questionBadge.addEventListener("click", () => {
        questionTab.click();
        tabParentMob.classList.remove("open");
      });
    }

    if (starsBadge) {
      starsBadge.addEventListener("click", () => {
        reviewsTab.click();
        tabParentMob.classList.remove("open");
      });
    }

    if (reviewsBadge) {
      reviewsBadge.addEventListener("click", () => {
        reviewsTab.click();
        tabParentMob.classList.remove("open");
      });
    }
  };

  updateReviewsTab();
  updateQuestionTab();
}

document.addEventListener("DOMContentLoaded", tabTitleCount);
